import { LoginService } from './../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
const suppliesOrdersByPkMutation  = gql`query supplies_orders_by_pk($id: uuid!) {
  supplies_orders_by_pk(id: $id) {
    id
    created_at
    updated_at
    short_id
    supply_coupon_id
    total_amount
    tax_amount
    tax_percentage
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    suppliers_id
    supplier{
      id
      name
      logo
      business_name
      email
      phone
    }
    dental_practice_id
    dental_practice{
      id
      name
      phone
      email
    }
    dental_professional_id
    dental_professional{
      id
      name
      phone
      email
    }
    dental_supplier_id
    dental_supplier{
      id
      name
      phone
      email
    }
    account_pay_details
    coupon_discount
    sub_total
    order_number
    supplies_order_items(order_by:{created_at: desc}) {
      id
      created_at
      price
      quantity
      supplies_order_id
      supply_id
      supply {
        id
        name
      }
      supply_deal_id
      supply_deal{
        id
        name
        type
        buy_quantity
        get_quantity
        price
        description
        image
      }
      free_quantity
      supply_variant_attributes
      supply_variant_id
      supply_variant {
        id
        title
        actual_price
        attributes
        available_stock
        color
        created_at
        details
        image
        selling_price
        stock_unit
        price_unit
        make_default
      }
      updated_at


    }
    supplies_order_notes{
      id
      created_at
      updated_at
      supplies_order_id
      status
      message
    }
  }
}`;
const suppliesOrdersByPkSubs  = gql`subscription supplies_orders_by_pk($id: uuid!, $user_id:uuid!) {
  supplies_orders_by_pk(id: $id) {
    id
    created_at
    updated_at
    short_id
    supply_coupon_id
    total_amount
    tax_amount
    tax_percentage
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    dental_practice_id
    dental_practice{
      id
      name
      phone
    }
    dental_professional_id
    dental_professional{
      id
      name
      phone
    }
    dental_supplier_id
    dental_supplier{
      id
      name
      phone
    }
    account_pay_details
    suppliers_id
    supplier{
      id
      name
      logo
      business_name
      email
      phone
    }
    coupon_discount
    sub_total
    order_number
    supplies_order_items(order_by:{created_at: desc}) {
      id
      created_at
      price
      quantity
      supplies_order_id
      supply_id
      status
      supply {
        id
        name
      }
      supply_deal_id
      supply_deal{
        id
        name
        type
        buy_quantity
        get_quantity
        price
        description
        image
      }
      free_quantity
      supply_variant_attributes
      supply_variant_id
      supply_variant {
        id
        title
        actual_price
        attributes
        available_stock
        color
        created_at
        details
        image
        selling_price
        stock_unit
        price_unit
        make_default
        supply_reviews_aggregate(where:{
          _or:[
            {dental_practice_id: {_eq: $user_id}},
            {dental_professional_id: {_eq: $user_id}},
            {dental_supplier_id:{ _eq: $user_id}}
          ]}){
          aggregate{
            count
          }
        }
      }
      updated_at
    }
    supplies_order_notes{
      id
      created_at
      updated_at
      supplies_order_id
      status
      message
      extra
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplierOrderByPkService {

  constructor(
    private apollo: Apollo,
    private loginService: LoginService) { }

/* --------------------------- suppliesOrdersByPk --------------------------- */
  getSuppliesOrdersByPk(id: string): Observable<any>{
    return this.apollo.use('external').query({
      query: suppliesOrdersByPkMutation,
      variables: {
        id
      }
    }).pipe(pluck('data', 'supplies_orders_by_pk'));
  }

  /* --------------------------- suppliesOrdersByPk --------------------------- */
  getSuppliesOrdersByPkSubscription(id: string): Observable<any>{
    return this.apollo.use('external').subscribe({
      query: suppliesOrdersByPkSubs,
      variables: {
        id,
        user_id: this.loginService.getLoginData().id
      }
    }).pipe(pluck('data', 'supplies_orders_by_pk'));
  }


}
